// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fixture-matches-locked-dates .modal2__container {
    width: 40%;
}

.fixture-matches-locked-dates__content {
    padding: 18px 40px;
}

.fixture-matches-locked-dates__dates-content {
    height: 74px;
}

.fixture-matches-locked-dates__buttons {
    border-top: 1px solid var(--new-gray-background-color);
    padding: 12px 16px;
    display: flex;
    justify-content: flex-end;
}

.fixture-matches-locked-dates__types {
    display: flex;
    gap: 24px;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    width: fit-content;
    margin-top: 16px;
}

.fixture-matches-locked-dates__types .MuiFormControlLabel-root {
    margin-left: 0;
}

.fixture-matches-locked-dates__types .MuiRadio-root {
    padding: 0;
}

.fixture-matches-locked-dates__types.MuiFormGroup-row {
    flex-direction: column;
}

.fixture-matches-locked-dates__types .baloa-table{
    color: var(--primary-very-dark-color);
    margin-left: 8px;
}
.fixture-matches-locked-dates__dates {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid var(--new-gray-background-color);
    margin-top: 12px;
}

.fixture-matches-locked-dates__date {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    max-width: 240px;
    margin: 0;
    margin-top: 16px;
}

.fixture-matches-locked-dates__date .input-field-label {
    font-size: 16px;
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
    position: relative;
    width: fit-content;
    text-wrap: nowrap;
    top: unset;
}

.fixture-matches-locked-dates__date .input-field-input {
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    padding: 12px 8px;
    max-width: 120px;
    margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-fixture-matches-locked-dates-modal/TournamentFixtureMatchesLockedDatesModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sDAAsD;IACtD,kBAAkB;IAClB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sDAAsD;IACtD,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,gCAAgC;IAChC,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,kDAAkD;IAClD,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":[".fixture-matches-locked-dates .modal2__container {\n    width: 40%;\n}\n\n.fixture-matches-locked-dates__content {\n    padding: 18px 40px;\n}\n\n.fixture-matches-locked-dates__dates-content {\n    height: 74px;\n}\n\n.fixture-matches-locked-dates__buttons {\n    border-top: 1px solid var(--new-gray-background-color);\n    padding: 12px 16px;\n    display: flex;\n    justify-content: flex-end;\n}\n\n.fixture-matches-locked-dates__types {\n    display: flex;\n    gap: 24px;\n    align-items: center;\n    justify-content: flex-start;\n    flex-direction: column;\n    width: fit-content;\n    margin-top: 16px;\n}\n\n.fixture-matches-locked-dates__types .MuiFormControlLabel-root {\n    margin-left: 0;\n}\n\n.fixture-matches-locked-dates__types .MuiRadio-root {\n    padding: 0;\n}\n\n.fixture-matches-locked-dates__types.MuiFormGroup-row {\n    flex-direction: column;\n}\n\n.fixture-matches-locked-dates__types .baloa-table{\n    color: var(--primary-very-dark-color);\n    margin-left: 8px;\n}\n.fixture-matches-locked-dates__dates {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-top: 1px solid var(--new-gray-background-color);\n    margin-top: 12px;\n}\n\n.fixture-matches-locked-dates__date {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    max-width: 240px;\n    margin: 0;\n    margin-top: 16px;\n}\n\n.fixture-matches-locked-dates__date .input-field-label {\n    font-size: 16px;\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n    position: relative;\n    width: fit-content;\n    text-wrap: nowrap;\n    top: unset;\n}\n\n.fixture-matches-locked-dates__date .input-field-input {\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    padding: 12px 8px;\n    max-width: 120px;\n    margin-left: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
